import React from "react";
import authCommonLogo from "@assets/svg/logos/auth_common_logo.svg";
import { OptimizedSvg } from "@components/common/OptimizedSvg";

const SidebarLogo: React.FC = () => (
	<div className="sidebar-header w-full">
		<div className="sidebar-branding flex w-full shrink-0 flex-col items-center text-center">
			<OptimizedSvg
				src={authCommonLogo}
				alt="Skills Punjab"
				className="sidebar-branding__logo sidebar-branding__logo--expanded [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-full"
				cacheKey="sidebar-brand-logo"
			/>
		</div>
	</div>
);

export default SidebarLogo;
